import { PaymentTypes, InvoiceStatuses } from './Constants'

const InvoiceStatusHelper = {
  shouldInvoiceBePaid: function (invoice) {
    const invoiceStatus = parseInt(invoice.invoice_status_id)
    const paymentType = parseInt(invoice.current_payment_type_id)

    let shouldInvoiceBePaid = false
    if (
      (invoiceStatus === InvoiceStatuses.UNPAID || invoiceStatus === InvoiceStatuses.PARTLY_PAID) &&
      (
        paymentType === PaymentTypes.BANK_GIRO ||
        paymentType === PaymentTypes.DIRECT_DEBIT ||
        paymentType === PaymentTypes.DIRECT_TRANSFER ||
        paymentType === PaymentTypes.ELECTRONIC_INVOICE
      )
    ) {
      shouldInvoiceBePaid = true
    }
    return shouldInvoiceBePaid
  }
}

export default InvoiceStatusHelper
